export default function ReceiptPriceItem({
  cost,
  currency,
  label,
}: {
  cost: number
  currency: string
  label: string
}): React.ReactElement {
  return (
    <div className="flex justify-between">
      <span className="uppercase tracking-wide text-gray-light-fade">{label}</span>
      <span className="uppercase">
        <span className="font-medium">{cost}</span> {currency}
      </span>
    </div>
  )
}
